import { render, staticRenderFns } from "./platformOfquestionBankList.vue?vue&type=template&id=7f765bac"
import script from "./platformOfquestionBankList.vue?vue&type=script&lang=js"
export * from "./platformOfquestionBankList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports